import * as yup from 'yup';

export const suggestionSchema = yup.object().shape({
  suggestion: yup.string().required('Este campo é obrigatório.'),
});
